import update from 'immutability-helper';
import { handleActions } from 'redux-actions';

import {
  LOAD_ORGANISATION_LIST,
  LOAD_ORGANISATION_LIST_SUCCESS,
  LOAD_ORGANISATION_LIST_ERROR,
  LOAD_ORGANISATION_DETAIL,
  LOAD_ORGANISATION_DETAIL_SUCCESS,
  LOAD_ORGANISATION_DETAIL_ERROR,
} from '../type';
import { initialState } from './initialize-state';

const organisationReducer = handleActions(
  new Map([
    [
      LOAD_ORGANISATION_LIST,
      state => {
        return update(state, {
          loadingStatus: {
            loadOrganisationListLoading: { $set: true },
          },
        });
      },
    ],
    [
      LOAD_ORGANISATION_LIST_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            loadOrganisationListLoading: { $set: false },
          },
          organisationList: {
            data: { $set: action.payload.data },
            offset: { $set: action.payload.offset },
            limit: { $set: action.payload.limit },
            total: { $set: action.payload.total },
          },
        });
      },
    ],
    [
      LOAD_ORGANISATION_LIST_ERROR,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            loadOrganisationListLoading: { $set: false },
          },
          error: { $set: action.payload },
        });
      },
    ],
    //Load organisation detail
    [
      LOAD_ORGANISATION_DETAIL,
      state => {
        return update(state, {
          loadingStatus: {
            organisationDetailLoading: { $set: true },
          },
        });
      },
    ],
    [
      LOAD_ORGANISATION_DETAIL_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            organisationDetailLoading: { $set: false },
          },
          organisationDetail: {
            $set: action.payload,
          },
        });
      },
    ],
    [
      LOAD_ORGANISATION_DETAIL_ERROR,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            organisationDetailLoading: { $set: false },
          },
          error: { $set: action.payload },
        });
      },
    ],
  ]),
  initialState,
);
export default organisationReducer;
